var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oui:ml-create-advanced-job",
    clipPath: "url(#clip0_58_13122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32.3945C7.163 32.3945 0 25.2315 0 16.3945C0 7.55753 7.163 0.394531 16 0.394531C24.837 0.394531 32 7.55753 32 16.3945H30C30 8.66253 23.732 2.39453 16 2.39453C8.268 2.39453 2 8.66253 2 16.3945C2 24.1265 8.268 30.3945 16 30.3945V32.3945Z",
    fill: "white",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27 20.3945V32.3945H25V20.3945H27ZM22 24.3945V32.3945H20V24.3945H22ZM32 22.3945V32.3945H30V22.3945H32ZM17 9.39453V15.3945H23V17.3945H17V23.3945H15V17.3945H9V15.3945H15V9.39453H17Z",
    fill: "white",
    fillOpacity: 0.48
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_13122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.394531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.2f3b9306d3016b26cb4496622522c001.svg";
export { ForwardRef as ReactComponent };